import jQuery from 'jquery';

const $ = jQuery;

require("./modules/polyfill");

require("./modules/useragent");

require("./modules/smoothscroll");

require("./modules/site");



